module.exports = __webpack_public_path__ + "static/media/VIIe.a16fce86.jpg";